import React from 'react'

import { AttachmentValue } from 'features/views/attributes/types'

import { Box } from 'ui/components/Box'
import { Button } from 'ui/components/Button'
import { Field } from 'ui/components/Field'
import { RightSlotContentStyles, RootStyles } from 'ui/components/Input/Input.css'
import { ScrollArea } from 'ui/components/ScrollArea'
import { Tag } from 'ui/components/Tag'

import { useSectionAttachmentAttributeEditorState } from './hooks/useSectionAttachmentAttributeEditorState'
import { SectionAttributeEditorProps } from './types'

type SectionAttachmentAttributeEditorProps = SectionAttributeEditorProps<AttachmentValue[]>

export const SectionAttachmentAttributeEditor: React.FC<SectionAttachmentAttributeEditorProps> = ({
    label,
    value,
    onChange,
    isReadOnly,
}) => {
    const { localValue, onRemoveAttachment, onUploadClick, isLoading } =
        useSectionAttachmentAttributeEditorState({ value, onChange })

    // This field type is never editable, so we don't need to show an editor.
    return (
        <Field label={label}>
            <Box
                className={RootStyles.styleFunction({
                    isReadOnly,
                    size: 'm',
                    variant: 'default',
                })}
                style={{
                    cursor: 'pointer',
                }}
            >
                <ScrollArea direction="horizontal" type="auto" minWidth={0} maxWidth="full">
                    <Box flex center gap="xs">
                        {localValue?.map((attachment) => (
                            <Box key={attachment.url} minWidth={0} maxWidth="full">
                                <Tag
                                    size="xs"
                                    startIcon={{ name: 'Paperclip' }}
                                    shade="light"
                                    color="Neutral"
                                    noShrink
                                    tabIndex={-1}
                                    style={{
                                        wordBreak: 'break-word',
                                        maxWidth: '100%',
                                    }}
                                    showRemoveButton
                                    onRemove={() => onRemoveAttachment(attachment.url)}
                                    {...attachment.attributes}
                                >
                                    {attachment.name}
                                </Tag>
                            </Box>
                        ))}
                    </Box>
                </ScrollArea>
                <Box className={RightSlotContentStyles.styleFunction({})}>
                    <Button
                        variant="ghost"
                        startIcon={{ name: 'Upload' }}
                        size="xs"
                        onClick={onUploadClick}
                        aria-label="Upload file"
                        disabled={isLoading || isReadOnly}
                    />
                </Box>
            </Box>
        </Field>
    )
}
